import { render, staticRenderFns } from "./detectiondetail.vue?vue&type=template&id=0be10b4c&"
import script from "./detectiondetail.vue?vue&type=script&lang=js&"
export * from "./detectiondetail.vue?vue&type=script&lang=js&"
import style0 from "./detectiondetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports